import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import ActionCreators from 'modules/order/store/reducers/actionCreators';
import { Creators as proposalCreators } from 'modules/resale/store/ducks/proposal';
import OrderSteps from 'modules/order/pages/OrderSteps';
import ChatCallCenter from 'pages/chats/ChatCallCenter';
import { ChatProvider } from 'pages/chats/ChatsContext';
import { checkCallCenterOsSearchAndRescueRoute } from 'helpers/checkCallcenterOrSearchAndRescue';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ChatFullScreenDialog() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { currentProposal, openProposalModal } = useSelector(
    ({ proposalStore }) => proposalStore
  );

  const handleClose = () => {
    const currentFilterParams = window.location.search.split('&');

    if (currentFilterParams?.[2]) history.goBack();

    if (!currentFilterParams?.[2]) {
      window.history.pushState(
        {},
        '',
        `${history.location.pathname}${
          currentFilterParams?.[0].includes('proposalId')
            ? ''
            : currentFilterParams?.[2]
            ? `${currentFilterParams?.[0]}&${currentFilterParams?.[2]}`
            : `${currentFilterParams?.[0]}`
        }`
      );
    }

    dispatch(
      proposalCreators.setProposalModalOpen(false, {
        dealerId: null,
        proposalId: null,
        groupId: null,
        viewType: null,
        currentProposalSection: null,
      })
    );
    dispatch(
      ActionCreators.setQueueData({
        proposal: {},
        currentStepProposalQueue: null,
        RequiredFieldsForCurrentStepCompleted: null,
        orderPlacedAtTheAutomaker: null,
        client: {},
        createdAt: null,
        delivery: {},
        comments: '',
        payment: {},
        seller: {},
        status: {},
        trim: {},
        updatedAt: null,
        filters: {
          model: null,
        },
      })
    );
    dispatch(ActionCreators.setCurrentVehicle(null));
  };

  const query = useQuery();
  const { dealerId }: any = useParams();

  useEffect(() => {
    const proposalIdByQuery = query.get('proposalId');

    if (proposalIdByQuery) {
      dispatch(
        proposalCreators.setProposalModalOpen(true, {
          dealerId,
          proposalId: proposalIdByQuery,
        })
      );
    }
  }, [query]);

  const OffStore = currentProposal?.viewType
    ? ['CALL_CENTER', 'SEARCH_AND_RESCUE'].includes(currentProposal?.viewType)
    : checkCallCenterOsSearchAndRescueRoute();

  return (
    <Dialog
      fullScreen
      open={openProposalModal}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      {openProposalModal && (
        <>
          {OffStore ? (
            <ChatProvider onModal>
              <ChatCallCenter onModal handleOnClickClose={handleClose} />
            </ChatProvider>
          ) : (
            <OrderSteps onModal onCloseModal={handleClose} />
          )}
        </>
      )}
    </Dialog>
  );
}

export default ChatFullScreenDialog;
